import { useEffect, useState } from 'react';
import { debounce } from 'lodash';

export const useDebouncedLoading = (state: boolean) => {
  const [isLoading, setIsLoading] = useState(false);

  const debouncedSetIsLoading = debounce(() => {
    setIsLoading(state);
  }, 200);

  useEffect(() => {
    debouncedSetIsLoading();

    return () => debouncedSetIsLoading.cancel();
  }, [state]);

  return isLoading;
};
